 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Unit of Measure
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryUOMFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryUOMFilterForm"
                            v-model="filtersUOM.uom"
                            :label="filtersUOMLabel.uom"
                            :error-messages="errors.collect('filterBusCls')"
                            data-vv-name="filterBusCls"
                            :data-vv-as="filtersUOMLabel.uom"
                            v-validate="'entry|max:4'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryUOMFilterForm"
                            v-model="filtersUOM.uomLongDesc"
                            :label="filtersUOMLabel.uomLongDesc"
                            :error-messages="errors.collect('filterBusClsDesc')"
                            data-vv-name="filterBusClsDesc"
                            :data-vv-as="filtersUOMLabel.uomLongDesc"
                            v-validate="'entry|max:40'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearUOMFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doUOMFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="uomHeaders"
          :items="uomItems"
          v-bind:options.sync="paginationUOM"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItems"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.uom }}</td>
              <td>{{ row.item.uomLongDesc }}</td>
              <td style="text-align: center">
                <v-btn icon color="primary" text type="submit" @click.prevent="assignUOM(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersUOMLabel: {
        uom: 'UOM',
        uomLongDesc: 'Description'
      },
      filtersUOM: {
        uom: undefined,
        uomLongDesc: undefined
      },
      uomItems: [],
      totalItems: 0,
      uomHeaders: [
        { text: 'UOM', align: 'left', value: 'uom' },
        { text: 'Description', align: 'left', value: 'uomLongDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationUOM: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      panel: [0]
    }
  },
  watch: {
    'paginationUOM': function (value) {
      this.fetchUOMData()
    }
  },
  mounted() {
    this.doClearUOMFilters()
  },
  methods: {
    closeDialog() {
      this.filtersUOM.uom = ''
      this.filtersUOM.uomLongDesc = ''
      this.$emit('close')
    },
    doClearUOMFilters() {
      this.filtersUOM.uom = ''
      this.filtersUOM.uomLongDesc = ''
      this.fetchUOMData()
    },
    doUOMFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryUOMFilterForm').then((result) => {
        if (result) {
          this.paginationUOM.page = 1
          this.fetchUOMData()
        }
      })
    },
    async fetchUOMData(options) {
      const apiUrl = this.menu.polItemUOMParams2
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationUOM
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let massageFilters = clone(this.filtersUOM)
          massageFilters.bPackage = this.bPackage
          massageFilters.scheme = this.polMaster.scheme
          massageFilters.planNo = this.selectedPlanNo
          massageFilters.riskNo = this.selectedRiskNo
          massageFilters.itemNo = this.polItem.itemNo
          massageFilters.busCls = this.polItem.busCls
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.paginationUOM.sortBy, this.paginationUOM.sortDesc)
          )
          this.uomItems = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((uom) => {
                const convertList = {
                  uom: uom.uom,
                  uomLongDesc: uom.uomLongDesc
                }
                this.uomItems.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    assignUOM(data) {
      this.$emit('assign-uom', data)
      this.$emit('close')
      this.doClearUOMFilters()
    }
  },
  computed: {
    menu() {
      return this.$store.state.underwriting.policyRiskItemSettings.menu
    },
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    selectedRiskNo() {
      return this.$store.state.underwriting.policy.selectedRiskNo
    },
    selectedPlanNo() {
      return this.$store.state.underwriting.policy.selectedPlanNo
    }
  },
  props: {
    polItem: {
      type: Object,
      default: null
    },
    bPackage: Boolean
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
